import React, { Fragment } from 'react';
import { Grid, Divider, Card, Button } from 'semantic-ui-react';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoader from '../UtilityComponents/withFullScreenLoading';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import './Registration.css';

const Registration = ({
  data: {
    title,
    explanation,
    payment,
    registrationpackets,
    sanitationspackets,
    doc,
  },
}) => {
  return (
    <Fragment>
      <Grid stackable className="Registration">
        <Grid.Row centered columns="equal">
          <h2 className="Page__Title">
            {renderDataAsPlainText(title)}
          </h2>
        </Grid.Row>
        <Divider />
        <Grid.Column width={16}>
          <Card fluid>
            <Card.Content>
              {renderDataAsHtml(explanation)}
              <a href={doc.url} download target="_blank" rel="noopener noreferrer" className="Registration__Download">
                <Button>
                  Download registratieformulier
                </Button>
              </a>
              <Divider />
              {renderDataAsHtml(payment)}
            </Card.Content>
          </Card>
        </Grid.Column>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Card fluid>
              <Card.Content>
                {renderDataAsHtml(registrationpackets)}
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column>
            <Card fluid>
              <Card.Content>
                {renderDataAsHtml(sanitationspackets)}
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Fragment>
  );
};

export default withDataFetch(withFullScreenLoader(Registration), 'registratie');



// WEBPACK FOOTER //
// ./src/components/Registration/index.js